export enum DashboardType {
    CUSTOM    = 'custom',
    PROJECT   = 'project',
    USER      = 'user',
}